import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Building2, Ship } from "lucide-react";
import { useDocumentTypes } from "@/hooks/useDocumentTypes";
import { cn } from "@/lib/utils";

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: docTabs = [] } = useDocumentTypes();

  const currentSection = location.pathname.split("/dashboard/")[1] || "";

  const items = [
    { label: "Control", icon: Ship, path: "/dashboard/embarques", section: "embarques" },
    { label: "Resumen", icon: LayoutDashboard, path: "/dashboard/resumen", section: "resumen" },
    ...docTabs.map((tab) => ({
      label: tab.title.length > 10 ? tab.title.slice(0, 9) + "…" : tab.title,
      icon: tab.icon,
      path: `/dashboard/${tab.slug}`,
      section: tab.slug,
    })),
    { label: "Directorio", icon: Building2, path: "/dashboard/directorio", section: "directorio" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-lg border-t border-border md:hidden safe-area-bottom">
      <div
        className="flex items-center h-14 px-1 overflow-x-auto flex-nowrap scrollbar-hide snap-x"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {items.map((item) => {
          const active = currentSection === item.section;
          return (
            <button
              key={item.section}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 min-w-[72px] h-full rounded-lg transition-colors shrink-0 snap-center",
                active
                  ? "text-primary"
                  : "text-muted-foreground active:text-foreground"
              )}
            >
              <item.icon className={cn("h-5 w-5", active && "drop-shadow-[0_0_6px_hsl(var(--primary)/0.5)]")} />
              <span className={cn("text-[10px] leading-tight", active ? "font-semibold" : "font-medium")}>
                {item.label}
              </span>
              {active && (
                <div className="absolute bottom-1 h-0.5 w-6 rounded-full bg-primary" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
